import RoomDuration from './RoomDuration.vue';
export default RoomDuration;
